export default __webpack_public_path__ + "static/media/mississippi-pattern.c8f9cb8d.png";